import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import translate from '../../../commonComponents/translate';

function JourneyProgress({ t, hideLabel, progress, height, active }) {
  const progressRound = Math.round(progress);

  return (
    <div className={cx('journey-progress', { active })}>
      {!hideLabel && (
        <div className="journey-progress-label">
          {t('journey_yourProgress')}
        </div>
      )}
      <div className="journey-progress-values">
        <div className="journey-progress-bar" style={{ height }}>
          <span style={{ width: `${Math.min(progressRound, 100)}%` }} />
        </div>
        <span className="journey-progress-value">{`${progressRound}%`}</span>
      </div>
    </div>
  );
}

JourneyProgress.propTypes = {
  t: PropTypes.func.isRequired,
  hideLabel: PropTypes.bool,
  progress: PropTypes.number.isRequired,
  height: PropTypes.string,
  active: PropTypes.bool,
};

JourneyProgress.defaultProps = {
  hideLabel: false,
  height: null,
  active: false,
};

export default translate(JourneyProgress);
